import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-user-avatar',
  imports: [
    NgClass,
  ],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
})
export class UserAvatarComponent {
  firstName = input.required<string>();
  lastName = input.required<string>();
  size = input<string>('s');

  get displayInitials(): string {
    return `${this.firstName().toUpperCase()[0]}${this.lastName().toUpperCase()[0]}`;
  }
}
